var _rect, _g, _path, _g2, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 20,
    viewBox: "0 0 38 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4702_4106",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 5,
    width: 6,
    height: 10
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.8,
    height: 8.8,
    transform: "matrix(-1 0 0 1 17.5 5.56836)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4702_4106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0534 12.6466L12.639 14.0124L9.22461 12.6466V8.54936L12.639 7.18359L16.0534 8.54936V12.6466Z",
    stroke: "#768390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22461 9.04688L12.639 10.2885L16.0534 9.04688",
    stroke: "#768390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6836 9.70703V14.3896",
    stroke: "#768390"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4702_4106",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 6,
    width: 5,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69844 7.86572C7.69844 7.03918 8.36848 6.36914 9.19501 6.36914H11.8984V15.1691H9.19501C8.36848 15.1691 7.69844 14.4991 7.69844 13.6726V7.86572Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4702_4106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0534 12.6466L12.639 14.0124L9.22461 12.6466V8.54936L12.639 7.18359L16.0534 8.54936V12.6466Z",
    stroke: "#768390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22461 9.04688L12.639 10.2885L16.0534 9.04688",
    stroke: "#768390"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99657 3.1582C5.8939 3.1582 5 4.0521 5 5.15478V14.8437C5 15.9464 5.8939 16.8403 6.99657 16.8403H11.187C12.2897 16.8403 13.1836 15.9464 13.1836 14.8437V5.15478C13.1836 4.0521 12.2897 3.1582 11.187 3.1582H6.99657Z",
    stroke: "#768390"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3869 6.64408L14.8045 5.32021",
    stroke: "#768390"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4329 7.18275L16.6995 6.61468",
    stroke: "#768390"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98242 5.60938L10.1552 5.60937",
    stroke: "#768390"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14L23.828 5.54H25.124L29 14H27.428L26.396 11.624L27.02 12.044H21.944L22.592 11.624L21.56 14H20ZM24.464 7.196L22.772 11.204L22.46 10.832H26.492L26.24 11.204L24.512 7.196H24.464ZM29.936 14V5.54H33.632C34.56 5.54 35.276 5.76 35.78 6.2C36.292 6.64 36.548 7.252 36.548 8.036C36.548 8.556 36.432 9 36.2 9.368C35.976 9.736 35.652 10.02 35.228 10.22C34.804 10.412 34.304 10.508 33.728 10.508L33.896 10.28H34.304C34.64 10.28 34.94 10.368 35.204 10.544C35.468 10.72 35.684 10.988 35.852 11.348L37.088 14H35.384L34.136 11.252C34.024 10.972 33.852 10.788 33.62 10.7C33.396 10.612 33.124 10.568 32.804 10.568H31.484V14H29.936ZM31.484 9.428H33.38C33.924 9.428 34.336 9.316 34.616 9.092C34.904 8.86 35.048 8.524 35.048 8.084C35.048 7.644 34.904 7.312 34.616 7.088C34.336 6.864 33.924 6.752 33.38 6.752H31.484V9.428Z",
    fill: "#768390"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/ar.1f8d6c43fa3fd17c94e74e4715c51307.svg";
export { ForwardRef as ReactComponent };